import { HttpRequestBuilder15f2nnx9sjuv1 as HttpRequestBuilder } from '../request/HttpRequest.mjs';
import {
  skipSaveBodyqewhiekddpy3 as skipSaveBody,
  get_isSaved1yor47kvbhumv as get_isSaved,
} from '../plugins/SaveBody.mjs';
import { unwrapCancellationException1zvbmufui4i9c as unwrapCancellationException } from '../utils/ExceptionUtils.nonJvm.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import {
  save1hc0jjdmqj6mp as save,
  SavedHttpResponsendyse4i0h687 as SavedHttpResponse,
} from '../call/SavedCall.mjs';
import { get_job2zvlvce9o9a29 as get_job } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Job.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { CompletableJob1w6swnu15iclo as CompletableJob } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CompletableJob.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  Companion_instancejy2056q2ma5w as Companion_instance,
  _Result___init__impl__xyqfz832zdzqrocazzs as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
  _Result___get_value__impl__bjfvqg9vwgdwmhxc4m as _Result___get_value__impl__bjfvqg,
  _Result___get_isFailure__impl__jpiriv2yxkms7bg2hpm as _Result___get_isFailure__impl__jpiriv,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  canceldn4b3cdqcfny as cancel,
  Companion_getInstance1wcuorfuztxv3 as Companion_getInstance,
} from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannel.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { resolveOriginxsq87mgr6jqi as resolveOrigin } from '../call/DelegatedCall.mjs';
import { DefaultHttpResponse2wnrinzo0twhn as DefaultHttpResponse } from './DefaultHttpResponse.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var HttpStatementClass;
function HttpStatement() {
  if (HttpStatementClass === VOID) {
    class $ {
      constructor(builder, client) {
        this.s5x_1 = builder;
        this.t5x_1 = client;
      }
      *t5z($completion) {
        return yield* this.u5z($completion);
      }
      *u5x($completion) {
        $l$block: {
          // Inline function 'io.ktor.client.plugins.unwrapRequestTimeoutException' call
          try {
            var builder = (new (HttpRequestBuilder())()).z5o(this.s5x_1);
            skipSaveBody(builder);
            var call = yield* this.t5x_1.g5l(builder, $completion);
            return call.a5k();
          } catch ($p) {
            if ($p instanceof CancellationException()) {
              var cause = $p;
              throw unwrapCancellationException(cause);
            } else {
              throw $p;
            }
          }
        }
      }
      *u5z($completion) {
        $l$block: {
          // Inline function 'io.ktor.client.plugins.unwrapRequestTimeoutException' call
          try {
            var builder = (new (HttpRequestBuilder())()).z5o(this.s5x_1);
            var call = yield* this.t5x_1.g5l(builder, $completion);
            var result = (yield* save(call, $completion)).a5k();
            yield* this.v5x(call.a5k(), null, $completion);
            return result;
          } catch ($p) {
            if ($p instanceof CancellationException()) {
              var cause = $p;
              throw unwrapCancellationException(cause);
            } else {
              throw $p;
            }
          }
        }
      }
      *v5x(_this__u8e3s4, cause, $completion) {
        var tmp = get_job(_this__u8e3s4.ww());
        var job = isInterface(tmp, CompletableJob()) ? tmp : THROW_CCE();
        // Inline function 'kotlin.runCatching' call
        var tmp_0;
        try {
          // Inline function 'kotlin.Companion.success' call
          var value = engineContentForCleanup(_this__u8e3s4);
          tmp_0 = _Result___init__impl__xyqfz8(value);
        } catch ($p) {
          var tmp_1;
          if ($p instanceof Error) {
            var e = $p;
            // Inline function 'kotlin.Companion.failure' call
            tmp_1 = _Result___init__impl__xyqfz8(createFailure(e));
          } else {
            throw $p;
          }
          tmp_0 = tmp_1;
        }
        // Inline function 'kotlin.Result.getOrNull' call
        var this_0 = tmp_0;
        var content = _Result___get_isFailure__impl__jpiriv(this_0) ? null : _Result___get_value__impl__bjfvqg(this_0);
        if (cause == null) {
          var contentIsClosedForRead = (content == null ? null : content.b4n()) === true;
          var contentCloseCause = content == null ? null : content.g4m();
          if (contentIsClosedForRead && contentCloseCause == null) {
            job.o13();
          } else {
            // Inline function 'io.ktor.client.statement.toCancellationException' call
            var message = 'Response body was abandoned';
            var tmp0_elvis_lhs = contentCloseCause instanceof CancellationException() ? contentCloseCause : null;
            var tmp$ret$5 = tmp0_elvis_lhs == null ? CancellationException().p(message, contentCloseCause) : tmp0_elvis_lhs;
            job.gy(tmp$ret$5);
          }
        } else {
          // Inline function 'io.ktor.client.statement.toCancellationException' call
          var message_0 = 'Exception occurred during request execution';
          var tmp0_elvis_lhs_0 = cause instanceof CancellationException() ? cause : null;
          var tmp$ret$6 = tmp0_elvis_lhs_0 == null ? CancellationException().p(message_0, cause) : tmp0_elvis_lhs_0;
          job.gy(tmp$ret$6);
        }
        // Inline function 'kotlin.runCatching' call
        var tmp_2;
        try {
          var tmp_3;
          if (content == null) {
            tmp_3 = null;
          } else {
            cancel(content);
            tmp_3 = Unit_instance;
          }
          // Inline function 'kotlin.Companion.success' call
          var value_0 = tmp_3;
          tmp_2 = _Result___init__impl__xyqfz8(value_0);
        } catch ($p_0) {
          var tmp_4;
          if ($p_0 instanceof Error) {
            var e_0 = $p_0;
            // Inline function 'kotlin.Companion.failure' call
            tmp_4 = _Result___init__impl__xyqfz8(createFailure(e_0));
          } else {
            throw $p_0;
          }
          tmp_2 = tmp_4;
        }
        yield* job.dy($completion);
        return Unit_instance;
      }
      toString() {
        return 'HttpStatement[' + this.s5x_1.h5l_1.toString() + ']';
      }
    }
    initMetadataForClass($, 'HttpStatement', VOID, VOID, VOID, [1, 0, 2]);
    HttpStatementClass = $;
  }
  return HttpStatementClass;
}
function engineContentForCleanup(_this__u8e3s4) {
  if (get_isSaved(_this__u8e3s4))
    return Companion_getInstance().e4o_1;
  var origin = resolveOrigin(_this__u8e3s4);
  var tmp;
  if (origin instanceof DefaultHttpResponse()) {
    tmp = origin.b5z_1;
  } else {
    if (origin instanceof SavedHttpResponse()) {
      tmp = Companion_getInstance().e4o_1;
    } else {
      tmp = null;
    }
  }
  return tmp;
}
//region block: exports
export {
  HttpStatement as HttpStatement3zxb33q8lku,
};
//endregion

//# sourceMappingURL=HttpStatement.mjs.map
